
import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware"; 
import { IPETest, IPETestCategory } from "./interfaces";
import { ID } from "src/libs/interfaces/layouts";
import { getStorage } from "src/settings/zustand";

export interface ITestsStore {
    currentTest: IPETest
    currentStep:number
    currentStepValue:any
    waybill: string[]
    tryCount: number
    results: any[]
    genTests: IPETest[]
    genCurrentID: ID
    genTest: IPETest
    genStep: number,    
    testCategories: IPETestCategory[]
    currentTestCategories: IPETestCategory[]
    userResults: any,
    lastResults: any[] 
}
export const useTestsStore: any = create( 
    devtools( 
        persist<ITestsStore>( 
            (set: any, get: any ) => ({ 
                currentTest: {} as IPETest,
                currentStep: 0,
                currentStepValue: null,
                waybill: [],
                tryCount: 0,
                results: [],
                genTests: [] as IPETest[],
                genCurrentID: "-1",
                genTest: {} as IPETest,
                genStep: 0,
                testCategories : [],
                currentTestCategories: [],
                userResults: {},
                lastResults: []
            }),
            {
                name: 'pe-tests-storage', 
                storage: createJSONStorage( getStorage ), 
            } 
        )
    )
)